module.exports = __webpack_public_path__ + "static/img/banner.6c5b1d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/test-drive/banner.jpg
// module id = xouN
// module chunks = 1